import Markdown from '@/components/Markdown'
import Image from 'next/image'
import { Row, Col } from 'antd'

const AboutUs = () => {
  return (
    <div className="container pb-12">
      <h1 className="m-0 py-12 text-center text-4xl font-bold">关于灵缇互娱</h1>
      <Row>
        <Col md={{ span: 12, push: 6 }} xs={24}>
          <Markdown
            content={`
## 灵缇互娱 

灵缇互娱是领先的智力运动综合服务商，旗下拥有自主研发的编排系统、线下赛事数字信息化系统、线上赛事及牌例系统、运动员管理及排名系统、复式发牌机、协码啦效率软件等赛事专用软硬件产品，并提供赛事、传媒、文创、直播等智力运动专业服务。

灵缇互娱广受业内好评，先后被中国职工文体协、中企体协、中国计算机学会、中国体育彩票、平安人寿、华福证券、石家庄市体育总会、青岛掼协、深圳掼协、深圳电子竞技行业协会、邢台掼协、苏州掼协、通州掼协、北京大学光华管理校友会、长江商学院校友会、中欧国际商学院校友会、上海交大安泰校友会、南京大学校友会、苏州大学校友会、雄安江苏商会、无锡温州商会、青岛江苏商会、北京渭南商会、济宁苏鲁商会、山东海门商会、北京德阳商会、苏州川渝商会、苏州抚州商会、三兔扑克、青藏冰泉、古井贡酒、国窖、太平仙草等近万家单位采用。

### 灵缇互娱编排系统 

灵缇互娱编排系统是苏州瑞立思科技有限公司旗下的全线赛事服务商平台，业务包括自研技术领先的软件赛事平台、赛事(专业+休闲)周边产品(专业扑克、专用桌椅、生活场景物品)等等。  

灵缇互娱编排系统提供全流程无纸化、信息化的赛事服务，包括赛事创建、报名、组队、记分、桌次编排等功能。依托苏州瑞立思科技有限公司丰富的技术经验，我们具备以下优势：  

* 全流程无纸信息化: 报名、组队、计分、编排、桌次等等，均可线上操作，方便快捷； 

* 依托后台实时处理技术，比分信息实时更新展示，选手裁判能对比赛形势一目了然； 

* 秒级数据实时备份，安全可靠，在发生灾难性大型网络攻击时依然能够从容应对；

* 最多支持万人现场比赛，数据处理顺滑，突发情况应对及时精准。

### 灵缇AI复式发牌机

灵缇AI复式发牌机又称灵缇互娱复式发牌机为由苏州瑞立思科技研制生产的灵缇智能博弈终端，是一款基于精密的机械原理和光电检测技术的自动发牌设备，能够快速、准确、公正地发牌，为扑克游戏提供公平、公正的比赛环境。

为了确保赛事的公平性，专家和学者研发了复式赛制，给所有桌发一样的牌，确保牌的固定性，并让所有的选手之间能充分对抗，最终通过成绩来评判对手的真实成绩。但同时，发牌就成为了业界一大难题。灵缇互娱牌复式发牌机为团队自研，享有独立的自主产权，产品特色：

* 采用自研工业级人工智能视觉识别技术，能识别市面上几乎所有牌种；

* 小巧轻便，即提即走；

* 使用网络与灵缇互娱系统相连，手机操作，即插即用；

* 一键发牌 · 内置海量牌库，大大方便各种赛事组织、赛事俱乐部线下培训抽取牌库；

* 售后服务一流，一年内有非人为质量问题包换。

![](/machine.jpg)

规格参数： 

* 尺寸：270mm * 230mm *215mm

* 接口：USBx1 HDMIx1 DC电源接口x1

* CPU：英伟达供应

* WiFi频段：2.4G、5G

* 蓝牙：4.2

* 电源：24V 4A AC to DC电源适配器

* 无线协议：802.11AC /a/b/g/n/ac

### 灵缇互娱微信小程序

灵缇互娱微信小程序是苏州瑞立思科技有限公司研发和运营的小程序，为赛事参与者提供赛事签到、计分和历史战绩查询等服务，给用户带来了方便快捷的参赛体验。  

灵缇互娱微信小程序以小巧、高效、便捷等优势为用户带来更流畅的参赛体验，用户可以通过搜索或者扫描赛事方提供的小程序二维码，完成比赛签到和积分计算，省去了繁琐的手动过程，提高了比赛效率。而且参赛者还可以查询历史战绩，留存个人比赛记录。  

此外，小程序还提供电子证书下载功能，参赛者可以随时下载保存自己的比赛证书。  

与此同时，小程序还开放了商业合作和购买周边商品的功能，进一步扩充了用户的使用体验，让用户在享受比赛乐趣的同时，也能体验到更多增值服务。

`}
          />
        </Col>
      </Row>
      <div className="text-center">
        <Image src="/mini-qrcode.jpg" alt="" width={300} height={300} />
      </div>
    </div>
  )
}
Object.assign(AboutUs as any, {
  title: '关于灵缇互娱 · 国内领先的球拍类与棋牌类赛事平台',
  description: '灵缇互娱（lingti）致力于打造专业赛事平台，覆盖匹克球/网球/羽毛球/乒乓球等球拍类项目与掼蛋/桥牌/升级等棋牌类项目的赛事编排、计分、晋级与排名服务。',
})

export default AboutUs
